// frontend/admin-portal/src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Input, Title, Alert } from "@fiberhome/shared-ui";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%)",
        padding: "1rem",
      }}
    >
      <div style={{ width: "100%", maxWidth: 420 }}>
        <Card>
          <div className="text-center mb-4">
            <Title level={2}>FiberHome</Title>
            <p className="text-muted mb-0" style={{ fontSize: 13 }}>
              Store & Showroom Management
            </p>
          </div>

          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <form onSubmit={onSubmit}>
            <Input
              label="Email"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="admin@fiberhome.local"
            />
            <Input
              label="Password"
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
            />
            <Button type="submit" variant="primary" block loading={loading}>
              Sign In
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
